<template>
    <div>
        <div v-if="isCollapsed" class="flex w-full">
            <div class="w-full flex relative items-center py-4 cursor-pointer py-10 lg:py-14" @click="toggleCollapse">
                <button
                    class="absolute right-0 flex items-center font-semibold text-left text-sm text-gray-500 hover:bg-gray-100"
                    type="button"
                >
                    <icon name="arrow-drop-up-line" size="34" />
                </button>
                <h3 class="text-lg font-medium">{{ title || '' }}</h3>
            </div>
        </div>
        <div v-if="!isCollapsed" class="grid xl:grid-cols-3 gap-12 py-10 lg:py-14">
            <div class="space-y-2">
                <div v-if="showCollapseButton" class="relative cursor-pointer" @click="toggleCollapse">
                    <button
                            class="absolute right-0 -top-1 flex items-center justify-between font-semibold text-left text-sm text-gray-500 hover:bg-gray-100 rounded"
                            type="button"
                    >
                        <icon name="arrow-drop-down-line" size="32" />
                    </button>
                    <h3 class="text-lg font-medium">{{ title }}</h3>
                </div>
                <h3 v-if="!showCollapseButton" class="text-lg font-medium">{{ title }}</h3>
                <p class="text-gray-500 text-sm">{{ description }}</p>
            </div>
            <div class="col-span-2 space-y-8">
                <slot/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
        },
        description: {
            type: String,
        },
        showCollapseButton: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isCollapsed: false,
        };
    },
    methods: {
        toggleCollapse() {
            this.isCollapsed = !this.isCollapsed;
        },
        // These are needed when controlling the collapse state from outside
        collapse() {
            this.isCollapsed = true;
        },
        expand() {
            this.isCollapsed = false;
        }
    },
}
</script>
